import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

interface UseFetchVendorOrdersParams {
  limit?: number;
  enabled?: boolean;
}

export const useFetchVendorOrders = (
  params: UseFetchVendorOrdersParams = {},
) => {
  const { limit = 10, enabled = true } = params;

  const queryFn = async ({ pageParam = 1 }) => {
    const response = await fetchClient.GET("/order/vendor", {
      params: {
        query: {
          page: typeof pageParam === "number" ? pageParam : 1,
          limit,
        },
      },
    });

    const error = response.error;
    if (error) throw error;
    return response.data;
  };

  const {
    data,
    error,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isFetchNextPageError,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["vendor", "orders", limit],
    queryFn,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.data?.pagination;
      if (pagination?.hasNextPage) return pagination.page + 1;
      return undefined;
    },
    enabled,
  });

  return {
    data,
    error,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isFetchNextPageError,
    refetch,
  };
};
